/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  Permanent Address Listings (active or inactive)
 */

import type { Listing as ListingType, MinPAListingData } from '@zcode/state-type'
import { Floorplan } from './building'
import Listing from './listing'

export const AddressListings = {
  fromJS: (data: readonly MinPAListingData[]): ReadonlyArray<ListingType<MinPAListingData>> => {
    if (Array.isArray(data)) {
      return data.map((item) => (item.building_id ? Floorplan.fromJS(item) : Listing.fromJS(item)))
    }
    return []
  },
}
